import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Row, Col, Button, Spinner, Form } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postDataUser } from '../ApiServices/ApiService';
// import { BsMic } from 'react-icons/bs';
import { FaStop, FaMicrophone, FaVideo } from "react-icons/fa";
//import axios from 'axios';
import Logo from '../assets/icons/logo2.jpeg';
import UserNav from './UserNav';
import { async } from 'q';
import { currentYear } from '../utils/currentYear.js';

const UsersQuestions = () => {
  const [searchParams] = useSearchParams();
  const testId = searchParams.get('id');
  const navigate = useNavigate();
  const [isRecording, setIsRecording] = useState(false);
  const [audioChunks, setAudioChunks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isGetAns, setIsGetAns] = useState(false);
  const [isNextQuestionLoading, setIsNextQuestionLoading] = useState(false);

  const audioStreamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const mediaVideoRecorderRef = useRef(null);
  const videoRef = useRef(null);
  const chunksRef = useRef([]);
  const [isMicBlinking, setIsMicBlinking] = useState(false);


  const [questions, setQuestions] = useState([]);
  const [total_questions, settotal_questions] = useState(0);

  const [totalQuestions, setTotalQuestions] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);


  const [violationCount, setViolationCount] = useState(0); // Track user violations Tab Detection-R
  const [showWarning, setShowWarning] = useState(false); // Track warning visibility Tab Detection-R
  const [warningCounter, setWarningCounter] = useState(0); // Track warning visibility Tab Detection-R

  const [isTestCompleted, setIsTestCompleted] = useState(false); //for Submit All answers

  var testTime = "";
  const [timer, setTimer] = useState(120); // 2 minutes in seconds
  const [fetchedTestTimeId, setFetchedTestTimeId] = useState(null);


  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [isTimerRunning, setIsTimerRunning] = useState(true);
  const [error, setError] = useState('Loading ...');
  const [respError, setRespError] = useState('');
  const [urls, setUrls] = useState([]);
  const [firstQuestion, setFirstQuestion] = useState(null)
  const [callscount, setcallscount] = useState(0)
  const [examEndedMessage, setExamEndedMessage] = useState("");

  const [speechSynth, setSpeechSynth] = useState(null); // For speech synthesis
  const [hasQuestionBeenRead, setHasQuestionBeenRead] = useState(false);
  const isNextQuestionInProgressRef = useRef(false);
  const pendingVideoUploadsRef = useRef([]);
  const lastRenderableQuestionRef = useRef(null);

  // start Tab Detection-R
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        handleViolation();
      }
    };

    const handleWindowBlur = () => {
      handleViolation();
    };

    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        // User exited fullscreen, trigger violation
        handleViolation();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("blur", handleWindowBlur);
    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("blur", handleWindowBlur);
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);


  const restoreFullScreen = () => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen().catch(err => {
        console.error("Error entering full-screen mode:", err);
      });
    } else if (document.documentElement.mozRequestFullScreen) { // Firefox
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari, Opera
      document.documentElement.webkitRequestFullscreen();
    } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
      document.documentElement.msRequestFullscreen();
    }
  };



  const updateExamStatus = async (testId, tabSwitchCount) => {
    try {
      const payload = {
        test_id: testId,
        tab_switch_count: tabSwitchCount
      };

      console.log("🔹 Sending tab switch count to Lambda:", tabSwitchCount);

      const resp = await postDataUser('candidate_test_questions_get_convo', payload);

      if (!resp.ok) {
        console.error("HTTP Error:", resp.status);
        return;
      }

      const respData = await resp.json();
      console.log("🔹 API Response:", respData);

      if (respData.exam_status === "ENDED") {
        console.log("✅ Exam status updated to ENDED in DynamoDB");

        // ✅ Show alert or message to user
        // alert("Your exam has been ended due to tab switching violations.");
        // const [examEndedMessage, setExamEndedMessage] = useState("");


        // ✅ Set state to stop fetching further questions
        setIsTestCompleted(true);

        // ✅ Stop the timer
        setIsTimerRunning(false);

        // ✅ Call handleSubmit() to auto-submit
        handleSubmit();
      }
    } catch (error) {
      console.error("❌ Error calling Lambda to end exam:", error);
    }
  };




  const handleViolation = () => {
    window.speechSynthesis.cancel(); // Stop any ongoing speech

    setWarningCounter(prevCount => {
      const newCount = prevCount + 1;
      console.log(`⚠ Violation Count: ${newCount}`);

      if (newCount >= 3) {  // End exam if 3rd violation occurs
        console.log("🚨 3rd violation reached. Ending exam...");
        setExamEndedMessage("Your exam has been ended due to tab switching violations.");
        setIsTestCompleted(true);
        setIsTimerRunning(false);
        handleSubmit(); // Auto-submit answers
      } else {
        setShowWarning(true);
        setViolationCount(newCount);
      }
      return newCount;
    });

    // restoreFullScreen(); // Restore full-screen mode
  };



  const startCapture = (qid, url) => {
    console.log("🎥 Starting video recording for qid:", qid);

    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        videoRef.current.srcObject = stream;
        videoRef.current.onloadedmetadata = () => {
          videoRef.current.muted = true;
          videoRef.current.play();
          mediaVideoRecorderRef.current = new MediaRecorder(stream);

          chunksRef.current = []; // ✅ Reset chunks before starting a new recording

          mediaVideoRecorderRef.current.ondataavailable = (event) => {
            if (event.data.size > 0) {
              chunksRef.current.push(event.data); // ✅ Collect recorded video data
            }
          };

          mediaVideoRecorderRef.current.onstop = () => {
            if (chunksRef.current.length === 0) {
              console.error("❌ No video data was recorded!");
              return;
            }

            const blob = new Blob(chunksRef.current, { type: "video/webm" });
            sendVideoBlobToBackend(blob, firstQuestion);
            console.log("🎬 Video recorded:", blob);
          };

          mediaVideoRecorderRef.current.start();
          console.log("🔴 Recording started...");
        };
      })
      .catch((err) => {
        console.error("❌ Error accessing camera:", err);
      });
  };


  const stopCapture = async () => {
    const recorder = mediaVideoRecorderRef.current;
    if (!recorder) {
      console.warn("⚠ No active recording to stop.");
      return;
    }

    return new Promise((resolve) => {
      const existingOnStop = recorder.onstop;

      recorder.onstop = (event) => {
        if (typeof existingOnStop === 'function') {
          try {
            existingOnStop(event);
          } catch (error) {
            console.error("❌ Error in existing recorder onstop handler:", error);
          }
        }

        const stream = videoRef.current?.srcObject;
        if (stream) {
          const tracks = stream.getTracks();
          tracks.forEach((track) => track.stop());
        }
        videoRef.current.srcObject = null;
        recorder.onstop = existingOnStop;
        resolve();
      };

      recorder.stop();
      console.log("🛑 Recording stopped.");
    });
  };

  const [checkQuestion, setCheckQuestion] = useState(false);

  useEffect(() => {
    if (questions.length > 0) {
      setFirstQuestion(questions[0]);
    }
  }, [questions, checkQuestion]);

  // Start video recording when first question is loaded
  // useEffect(() => {
  //   if (questions.length > 0 && currentQuestionIndex === 0) {
  //     console.log("🎥 First question loaded, starting video...");
  //     startCapture(questions[currentQuestionIndex]?.qid);
  //   }
  // }, [questions, currentQuestionIndex]);
  const [firstQuestionStarted, setFirstQuestionStarted] = useState(false);
  useEffect(() => {
    if (questions.length > 0 && currentQuestionIndex === 0 && !firstQuestionStarted) {
      console.log("🎥 First question loaded, starting video...");
      startCapture(questions[currentQuestionIndex]?.qid);
      setFirstQuestionStarted(true); // ✅ Ensure it starts only once
    }
  }, [questions, currentQuestionIndex, firstQuestionStarted]);



  // console.log('firstQuestion:', firstQuestion);

  const sendVideoBlobToBackend = async (blob) => {
    const currentQuestion = questions[currentQuestionIndex];
    console.log('currentQuestion :', questions[currentQuestionIndex])
    console.log('questions ', questions)

    if (!currentQuestion || !currentQuestion.video_url) {
      console.error('❌ No video URL found for question ${currentQuestion?.qid || "unknown"}');
      return;
    }

    const { url, fields } = currentQuestion.video_url;
    if (!url || !fields) {
      console.error('❌ Missing video upload URL or fields for question ${currentQuestion.qid}');
      return;
    }

    const formData = new FormData();
    formData.append("key", fields.key);
    formData.append("x-amz-security-token", fields["x-amz-security-token"]);
    formData.append("x-amz-signature", fields["x-amz-signature"]);
    formData.append("policy", fields.policy);
    formData.append("x-amz-algorithm", fields["x-amz-algorithm"]);
    formData.append("x-amz-date", fields["x-amz-date"]);
    formData.append("x-amz-credential", fields["x-amz-credential"]);
    formData.append("file", blob);

    console.log('⬆ Uploading video for question ${currentQuestion.qid}...', currentQuestion.qid);

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });
      console.log('response :', response)
      if (response.status === 204) {
        console.log(`✅! Video uploaded successfully for question ${currentQuestion.qid}`);
        chunksRef.current = []; // ✅ Clear chunks after successful upload
      } else {
        console.error('❌ Video upload failed for question ${currentQuestion.qid}');
      }
    } catch (error) {
      console.error('❌ Error uploading video for question ${currentQuestion.qid}:, error');
    }
  };


  useEffect(() => {
    console.log("urls:", urls);
  }, [urls]);

  const [questionChunksList, setQuestionChunksList] = useState([]);

  useEffect(() => {
    if (questions.length > currentQuestionIndex && !isTimerRunning) {
      setTimer(120);
      setIsTimerRunning(true);
    }
  }, [currentQuestionIndex]); //  Only triggers when the question index changes






  const fetchQuestion = async (prevQID = null, prevQAnswer = null, prevQType = null, retryCount = 0, shouldAppendQuestion = true) => {
    try {
      setLoading(true);
      console.log("Fetching question with test_id:", testId, "prevQID:", prevQID, "prevQAnswer:", prevQAnswer);

      const payload = prevQID
        ? { "test_id": testId, "prev_qid": prevQID, "prev_q_answer": prevQAnswer }
        : { "test_id": testId };

      const resp = await postDataUser('candidate_test_questions_get_convo', payload);
      setLoading(false);
      if (!resp.ok) {
        console.log("Response", resp)
        setError(`HTTP Error: ${resp.status}`);
        setLoading(false);
        return null;
      }

      const respData = await resp.json();
      setLoading(false);
      if (respData?.statusCode === 200) {
        setLoading(false);
        settotal_questions(respData?.total_no_of_jd_questions);
        if (respData?.message.toLowerCase() === 'success' || respData?.message.toLowerCase() === 'generating') {
          if (respData?.message.toLowerCase() === 'generating') {
            // ✅ refresh logic
            if (retryCount < 5) {
              setTimeout(() => {
                fetchQuestion(prevQID, prevQAnswer, prevQType, retryCount + 1, shouldAppendQuestion);
              }, 10000);
            } else {
              setError("Questions are taking too long to generate. Please try again later.");
              setLoading(false);
            }
            return null;


          } else {
            // When backend returns success with empty dataJ, treat it as end of questions.
            if (!respData?.dataJ || !respData?.dataJ?.q_text) {
              if (prevQID) {
                return { isLastQuestion: true };
              }

              setIsTestCompleted(true);
              setError(respData?.info || "Test is already completed");
              return null;
            }

            //✅  display the questions
            const newQuestion = respData.dataJ;
            console.log("🔹 New Question:", newQuestion);
            if (newQuestion.qid == 1) {
              const firstQuestionTime = parseInt(respData.question_time, 10);
              // console.log('first quesiton time :', firstQuestionTime)
              console.log("⏳ Setting timer for first question:", firstQuestionTime);
              // setTimer(!isNaN(firstQuestionTime) && firstQuestionTime > 0 ? firstQuestionTime : 120);
              setTimer(firstQuestionTime);
            }

            if (shouldAppendQuestion) {
              setQuestions((prevQuestions) => [...prevQuestions, newQuestion]);
            }

          }


          setLoading(false);
          setError('');
          return respData;

        } else {
          setError(respData.info || "Error fetching question");
          setLoading(false);
          return null;
        }

      } else {
        //handle !200 errors here
        setError(respData.info || "Error fetching question");
        setLoading(false);
        return null;
      }

    } catch (error) {
      console.error('❌ Error fetching question:', error);
      setError("Network Error");
      setLoading(false);
      return null;
    }
  };








  const isFirstFetch = useRef(true); // Track if the first fetch has been done

  useEffect(() => {
    if (testId && isFirstFetch.current) {
      console.log('calling fetchQuestion() for question ', currentQuestionIndex);
      fetchQuestion();
      isFirstFetch.current = false; // Mark the first fetch as done
    }
  }, [testId]);


  useEffect(() => {
    let timerId;
    if (isTimerRunning && timer > 0) {
      timerId = setTimeout(() => setTimer(timer - 1), 1000);
    } else if (timer <= 0) {
      handleRecordingStop(); // ✅ Stop recording when time is up

      // ✅ Instead of submitting, disable mic and show "Time's up!"
      setIsMicBlinking(false);
      setIsRecording(false);
    }

    return () => clearTimeout(timerId);
  }, [timer, isTimerRunning]);






  const handleRecordingStart = async () => {
    console.log("handleRecordingStart()............................");

    // Stop any ongoing speech when the mic starts recording
    window.speechSynthesis.cancel();

    setAudioChunks([]);
    setIsMicBlinking(true); // Start blinking

    try {
      audioStreamRef.current = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(audioStreamRef.current);

      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data.size > 0) {
          const audioBlob = new Blob([e.data], { type: 'audio/wav' });
          const reader = new FileReader();
          reader.onload = () => {
            console.log("handleRecordingStart onstop() onload()");
            const base64String = reader.result.split(',')[1];
            const activeQuestionId =
              (questions[currentQuestionIndex] || questions[questions.length - 1] || lastRenderableQuestionRef.current)?.qid;

            if (!activeQuestionId) {
              console.warn("⚠ Skipping audio transcription: missing active question id.");
              return;
            }

            convertBlobToText(activeQuestionId, base64String);
            convertBlobToTextFinal(activeQuestionId, base64String);
            // console.log("base64String", base64String);
          };
          reader.readAsDataURL(audioBlob);
          setQuestionChunksList((prevList) => [...prevList, e.data]);
        }
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      console.error('Error accessing microphone:', error);
    }
  };




  //stopMicTypes: MIC,SUBMIT,AUTOSUBMIT
  const handleRecordingStop = (stopMicTypes) => {
    console.log("handleRecordingStop()............................", stopMicTypes);
    if (mediaRecorderRef.current) {
      //console.log('mic stop')
      mediaRecorderRef.current.stop();
      if (audioStreamRef.current) {
        audioStreamRef.current.getTracks().forEach((track) => track.stop());
      }
      setIsRecording(false);
      setIsMicBlinking(false); // Stop blinking

      //console.log('onstop audioChunks:new ', audioChunks);
    } else {
      console.error('mediaRecorderRef.current', mediaRecorderRef.current);
    }
  };

  const handleMicClick = () => {
    console.log('Clicked');

    if (isRecording) {
      handleRecordingStop("MIC");
    } else {
      // Stop speech synthesis when mic starts recording
      window.speechSynthesis.cancel();
      handleRecordingStart();
    }
  };


  const uploadQuestionVideoBlob = async (question, blob, shouldClearChunks = false) => {
    console.log('📌 Received question for video upload:', question);

    if (!question || !question.video_url) {
      console.error("❌ Invalid question or missing video URL.");
      return;
    }

    console.log(`⬆ Starting video upload for qid: ${question.qid}...`);

    if (!blob) {
      console.warn(`⚠ No recorded video found for question ${question.qid}.`);
      return;
    }

    console.log('Video Blob:', blob); // Log the video blob

    const { url, fields } = question.video_url;
    if (!url || !fields) {
      console.error(`❌ Missing video upload URL or fields for question ${question.qid}`);
      return;
    }

    const formData = new FormData();
    formData.append("key", fields.key);
    formData.append("x-amz-security-token", fields["x-amz-security-token"]);
    formData.append("x-amz-signature", fields["x-amz-signature"]);
    formData.append("policy", fields.policy);
    formData.append("x-amz-algorithm", fields["x-amz-algorithm"]);
    formData.append("x-amz-date", fields["x-amz-date"]);
    formData.append("x-amz-credential", fields["x-amz-credential"]);
    formData.append("file", blob);

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });

      if (response.status === 204) {
        console.log(`✅ Video uploaded successfully for question ${question.qid}`);
        if (shouldClearChunks) {
          chunksRef.current = []; // ✅ Clear recorded chunks after upload
        }
      } else {
        console.error(`❌ Video upload failed for question ${question.qid}`);
      }
    } catch (error) {
      console.error(`❌ Error uploading video for question ${question.qid}:`, error);
    }
  };

  const trackVideoUpload = (uploadPromise) => {
    pendingVideoUploadsRef.current.push(uploadPromise);
    uploadPromise.finally(() => {
      pendingVideoUploadsRef.current = pendingVideoUploadsRef.current.filter((promise) => promise !== uploadPromise);
    });
    return uploadPromise;
  };

  const waitForPendingVideoUploads = async () => {
    const pendingUploads = [...pendingVideoUploadsRef.current];
    if (pendingUploads.length > 0) {
      console.log(`⏳ Waiting for ${pendingUploads.length} pending video upload(s)...`);
      await Promise.allSettled(pendingUploads);
    }
  };

  const uploadCurrentQuestionVideo = async (question) => {
    if (!chunksRef.current.length) {
      console.warn(`⚠ No recorded video found for question ${question?.qid}.`);
      return;
    }

    const blob = new Blob(chunksRef.current, { type: "video/webm" });
    await uploadQuestionVideoBlob(question, blob, true);
  };

  const handleNextQuestion = async (nextType, stopMicType) => {
    console.log('📌 Moving to next question...');

    if (isNextQuestionInProgressRef.current) {
      console.warn("⚠ Next question is already loading. Ignoring duplicate click.");
      return;
    }

    isNextQuestionInProgressRef.current = true;
    setIsNextQuestionLoading(true);

    try {
      window.speechSynthesis.cancel();

      if (mediaVideoRecorderRef.current) {
        console.log('⏳ Stopping current recording...');
        await stopCapture(); // Wait for the recording to stop
      } else {
        console.warn("⚠ No active recording found. Skipping stop.");
      }

      // Capture the correct question BEFORE updating index
      const previousQuestion =
        questions[currentQuestionIndex] || questions[questions.length - 1] || lastRenderableQuestionRef.current;
      console.log('previousQuestion for video upload:', previousQuestion);

      if (previousQuestion && chunksRef.current.length > 0) {
        console.log('Starting background video upload for question:', previousQuestion.qid);
        const videoBlob = new Blob(chunksRef.current, { type: "video/webm" });
        chunksRef.current = [];
        trackVideoUpload(uploadQuestionVideoBlob(previousQuestion, videoBlob));
      } else if (previousQuestion) {
        console.warn(`⚠ No recorded video found for question ${previousQuestion.qid}.`);
      } else {
        console.error("❌ No valid question found for video upload.");
      }

      // ✅ Only update index AFTER the next question is received
      console.log('📥 Fetching next question...');
      const prevQID = previousQuestion?.qid || null;
      const prevQAnswer = previousQuestion?.q_answer || "candidate didn't answer";

      const response = await fetchQuestion(prevQID, prevQAnswer, null, 0, false);
      if (response?.isLastQuestion) {
        setShowSubmitButton(true);
        return;
      }

      if (response?.dataJ) {
        const nextQuestion = response.dataJ;
        setQuestions((prevQuestions) => [...prevQuestions, nextQuestion]);
        setCurrentQuestionIndex((prevIndex) => prevIndex + 1);

        if (response.question_time) {
          setTimer(parseInt(response.question_time, 10) || 120);
        } else {
          setTimer(120);
        }

        setIsTimerRunning(true);
        setHasQuestionBeenRead(false);

        console.log("🎥 Starting new recording...");
        await new Promise(resolve => setTimeout(resolve, 500)); // ✅ Small delay to ensure video stream readiness
        startCapture(response?.dataJ?.qid);
      }
    } finally {
      isNextQuestionInProgressRef.current = false;
      setIsNextQuestionLoading(false);
    }
  };

  const convertBlobToText = async (qId, blobAudio) => {
    const payload = {
      "op": "audio_trans",
      "test_id": testId,
      "qid": qId,
      "audio_data": blobAudio
    };

    setIsGetAns(true);

    postDataUser('candidate_audio_transcription', payload)
      .then(resp => resp.json().then(respData => { // Pass resp here
        setIsGetAns(false);

        if (resp.status === 200) {  // ✅ resp is now defined
          if (respData.statusCode === 200) {
            // Find the LAST occurrence of the repeated question qid
            setQuestions((prevQuestions) => {
              const questionIndex = [...prevQuestions]
                .reverse()
                .findIndex((question) => question.qid === qId);

              if (questionIndex === -1) {
                console.warn("Repeated Question not found for qid:", qId);
                return prevQuestions;
              }

              const actualIndex = prevQuestions.length - 1 - questionIndex;
              const updatedQuestions = [...prevQuestions];

              updatedQuestions[actualIndex] = {
                ...updatedQuestions[actualIndex],
                q_answer: `${updatedQuestions[actualIndex].q_answer || ''} ${respData.dataJ.q_answer}`.trim(),
              };

              return updatedQuestions;
            });
          } else if (respData.statusCode === 500) {
            setError(respData.info);
          } else {
            setError('Network Error');
          }
        } else {
          console.log('Error in API response:', resp);
        }
      }))
      .catch((error) => {
        setIsGetAns(false);
        setError('Network Error');
        console.log('network error:', error);
      });
  };



  const convertBlobToTextFinal = async (qId, blobAudio) => {
    console.log('Service convertBlobToTextFinal qId', qId, 'blobAudio',);
    const payload = {
      "op": "audio_trans_final",
      "test_id": testId,
      "qid": qId,
      "audio_data": blobAudio
    }
    postDataUser('candidate_audio_transcription', payload).then(resp => {
      resp.json().then(respData => {
        if (resp.status === 200) {
          if (respData.statusCode === 200) {
            // comment the code due to q_answer is doubled
            // setQuestions((prevQuestions) => {
            //   const questionIndex = prevQuestions.findIndex((question) => question.qid === respData.dataJ.qId);

            //   if (questionIndex === -1) {
            //     return prevQuestions;
            //   }

            //   const updatedQuestions = [...prevQuestions];
            //   updatedQuestions[questionIndex] = {
            //     ...updatedQuestions[questionIndex],
            //     q_answer: respData.dataJ.q_answer,
            //   };
            //   return updatedQuestions;
            // });

          } else if (respData.statusCode === 500) {
            setError(respData.info);
            console.log('resp else  : ', resp.info);
          } else {
            setError('Network Error');
          }
        } else if (resp.status === 401 || resp.status === 403) {
          console.log('resp status else if : ', resp.status);
          if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            || respData.message === 'Access Denied') {
            //   callRefreshTokenApi('getSfeBatch', '');
          }
        } else {
          console.log('resp status else  : ', resp);
        }
      }).catch((error) => {
        setError('Network Error');
        console.log('network error:', error);
      });
    }).catch((error) => {
      setError('Network Error');
      console.log('network error:', error);
    });
  }


  const handleSubmit = async () => {
    console.log("✅ Submitting all answers...");

    window.speechSynthesis.cancel();
    setLoading(true);

    if (mediaVideoRecorderRef.current) {
      console.log('⏳ Stopping and uploading last question’s video...');
      // await stopCapture(); // ✅ Await the stopCapture function to ensure recording is stopped
      await Promise.race([
        stopCapture(),
        new Promise(resolve => setTimeout(() => {
          console.warn("⚠ stopCapture() took too long, continuing...");
          resolve();
        }, 5000)) // 5-second timeout
      ]);
      // stopCapture();

      const lastQuestion = questions[currentQuestionIndex];
      if (lastQuestion) {
        console.log('Uploading video for last question:', lastQuestion.qid);
        await uploadCurrentQuestionVideo(lastQuestion); // ✅ Await the video upload
      } else {
        console.warn("⚠ No last question found for video upload.");
      }
    } else {
      console.warn("⚠ No active recording found during final submission.");
    }

    await waitForPendingVideoUploads();

    const formattedAnswers = questions.map(question => ({
      qid: question.qid,
      q_text: question.q_text,
      q_answer: question.q_answer || "candidate didn't answer",
      q_tech: question.q_tech,
      tech_level: question.tech_level
    }));

    const payload = {
      test_id: testId,
      questions_answers: formattedAnswers
    };

    try {
      const response = await postDataUser('candidate_submit_answers', payload);
      const respData = await response.json();

      setLoading(false);

      if (response.status === 200 && respData.statusCode === 200) {
        console.log("✅ Test successfully submitted.");
        setQuestions([]);
        setIsTimerRunning(false);
        navigate(`/users-summary?id=${testId}`, { replace: true });
      } else {
        console.error("❌ Submission error:", respData.info);
        setRespError(respData.info || "Submission error.");
      }
    } catch (error) {
      console.error("❌ Submission failed:", error);
      setLoading(false);
      setRespError("Network error occurred.");
    }
  };







  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handleBackButton = () => {
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);






  const handleClearAns = (qId) => {
    setQuestions((prevQuestions) => {
      const questionIndex = prevQuestions.findIndex((question) => question.qid === qId);
      if (questionIndex === -1) {
        return prevQuestions;
      }

      const updatedQuestions = [...prevQuestions];
      updatedQuestions[questionIndex] = { ...updatedQuestions[questionIndex], q_answer: '' };
      return updatedQuestions;
    });
    setQuestionChunksList([]);
  };


  const currentQuestion = questions[currentQuestionIndex] || questions[questions.length - 1];

  useEffect(() => {
    if (currentQuestion?.q_text) {
      lastRenderableQuestionRef.current = currentQuestion;
    }
  }, [currentQuestion]);

  const displayQuestion = currentQuestion?.q_text ? currentQuestion : lastRenderableQuestionRef.current;
  const parsedCurrentQid = Number(displayQuestion?.qid);
  const currentQuestionNumber = Number.isFinite(parsedCurrentQid) && parsedCurrentQid > 0
    ? parsedCurrentQid
    : (currentQuestionIndex + 1);
  const totalQuestionCount = Number(total_questions) > 0 ? Number(total_questions) : 0;
  const isLastQuestion = totalQuestionCount > 0 && currentQuestionNumber >= totalQuestionCount;

  const headerStyle = {
    backgroundColor: '#edf2fb',
    padding: '2px',
    display: 'flex',  // Use flexbox for layout
    alignItems: 'center',  // Align items vertically in the center
    justifyContent: 'space-between',  // Add space between items
  };
  // *******

  const speakText = useCallback((text) => {
    if (window.speechSynthesis) {
      window.speechSynthesis.cancel(); // Ensure no overlapping audio

      const utterance = new SpeechSynthesisUtterance(text);
      utterance.rate = 1;

      // Stop speech if the user starts answering
      utterance.onstart = () => {
        if (isRecording) {
          window.speechSynthesis.cancel();
        }
      };

      // Try to find a voice matching "Zira" or similar characteristics
      const voices = window.speechSynthesis.getVoices();
      let ziraVoice = voices.find(voice =>
        voice.name.toLowerCase().includes("zira") ||
        (voice.lang.startsWith("en") && voice.name.toLowerCase().includes("female"))
      );

      if (ziraVoice) {
        utterance.voice = ziraVoice;
        console.log("Using voice:", ziraVoice.name);
      } else {
        console.log("No Zira-like voice found. Using default.");
      }

      setTimeout(() => {
        if (!isRecording) {
          window.speechSynthesis.speak(utterance);
          // Reset timer when the question is repeated
        }
      }, 100);

    }
  }, [isRecording]);



  useEffect(() => {
    const checkVoices = () => {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length > 0) {
        // Voices are loaded, you can now use them
        if (displayQuestion?.q_text && !hasQuestionBeenRead) {
          speakText(displayQuestion.q_text);
          setHasQuestionBeenRead(true);
        }
      } else {
        // Voices are not loaded yet, try again after a short delay
        setTimeout(checkVoices, 100);
      }
    };

    checkVoices();
  }, [displayQuestion, speakText, hasQuestionBeenRead]);

  const stopAudioStream = () => {
    if (audioStreamRef.current) {
      audioStreamRef.current.getTracks().forEach((track) => track.stop());
      audioStreamRef.current = null;
    }
  };


  // *********************************************



  return (
    <>
      {/* Warning Modal */}
      {showWarning && (
        <div className="warning-modal">
          <div className="warning-content">
            <p><strong>Warning:</strong> You switched tabs or minimized the window. Please stay on this page.</p>
            <button onClick={() => {
              setShowWarning(false);
              restoreFullScreen();
              if (displayQuestion?.q_text) {
                setTimeout(() => speakText(displayQuestion.q_text), 500);
              }
            }}>OK</button>
          </div>
        </div>
      )}

      <div className='user-qus-div'>
        <UserNav />
        <div style={{ display: 'flex', justifyContent: 'end', alignItems: "end", marginTop: '5px' }}>
          <video ref={videoRef} width="180" height="150" />
        </div>

        <div style={{ padding: '40px 15px', marginBottom: '20px' }}>
          <div className="question-div">
            <Row className="justify-content-center">
              <Col xs={12} md={12}>
                {/* ✅ Show Exam Ended Message if applicable */}
                {examEndedMessage ? (
                  <div className="text-center mt-4">
                    <h2 style={{ color: "red" }}>{examEndedMessage}</h2>
                    <Button variant="primary" onClick={handleSubmit}>
                      Go to Summary
                    </Button>
                  </div>
                ) : isTestCompleted && !examEndedMessage ? (  // Ensures button is not shown when revisiting
                  <div className="text-center mt-4">
                    <h2 style={{ color: "red" }}>Test is already completed.</h2>
                    <p>Contact the recruiter for Report.</p>
                  </div>
                ) : (
                  questions.length !== 0 ? (
                    <div>
                      <h2 className="text-center mb-4">Question {displayQuestion?.qid || currentQuestionNumber}</h2>
                      <p className="text-center">{displayQuestion?.q_text || ''}</p>

                      <div className="text-center mt-3">
                        <button onClick={() => speakText(displayQuestion?.q_text)}
                          className="btn btn-primary"
                          style={{ padding: '10px 20px', fontSize: '16px' }}>
                          Repeat Question
                        </button>
                      </div>

                      <div className='d-flex'>
                        <div className="text-center mt-3 flex-grow-1">
                          <textarea rows="7" readOnly className="form-control"
                            value={displayQuestion?.q_answer || ''}
                            placeholder="Please speak to answer..." />
                        </div>
                        <div style={{ display: 'grid' }}>
                          <div className="text-center align-self-center m-left">
                            <Button variant="dark" style={{ padding: '10px 30px' }}
                              onClick={() => handleClearAns(displayQuestion?.qid)}
                              disabled={isRecording || isNextQuestionLoading || timer <= 0}>
                              Clear
                            </Button>
                          </div>
                          <div className="text-center align-self-center m-left">
                            {isRecording ? (
                              <Button variant="outline-success" style={{ padding: '10px 40px' }}
                                onClick={handleMicClick}
                                className={isMicBlinking ? 'blinking' : ''} disabled={loading || isNextQuestionLoading}>
                                <FaStop className="icon qes-icon-size" />
                              </Button>
                            ) : (
                              <Button variant="outline-danger" style={{ padding: '10px 40px' }}
                                onClick={handleMicClick} disabled={isNextQuestionLoading || timer <= 0}>
                                <FaMicrophone className="icon qes-icon-size" />
                              </Button>
                            )}
                            {isRecording ? (
                              <div className="text-center mt-3 speak-text">
                                <p style={{ color: 'green' }}>You are speaking</p>
                              </div>
                            ) : (
                              <div className="text-center mt-3 speak-text">
                                <p style={{ color: 'red' }}>Click Mic to Speak</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="text-center mt-3">
                        <p style={{ color: timer <= 30 ? 'red' : '' }}>
                          Time Remaining: {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')}
                        </p>
                      </div>

                      <div className="text-center mt-3">
                        {showSubmitButton || isLastQuestion ? (
                          <Button variant="primary" onClick={handleSubmit} disabled={isRecording || isGetAns || isNextQuestionLoading}>
                            Submit All Answers
                          </Button>
                        ) : (
                          <Button variant="dark" onClick={() => handleNextQuestion('BUTTON', 'SUBMIT')}
                            disabled={isRecording || isGetAns || isNextQuestionLoading}>
                            {currentQuestionNumber}/{totalQuestionCount} Next Question {(isGetAns || isNextQuestionLoading) && <Spinner />}
                          </Button>
                        )}
                      </div>

                      {loading && (
                        <div className="spinner-overlay">
                          <Spinner animation="border" role="status">
                            <span className="sr-only"></span>
                          </Spinner>
                        </div>
                      )}
                      {respError && <p className='error-msg'>{respError}</p>}
                    </div>
                  ) : (
                    <div className="text-center mt-4">
                      {error ? (
                        <p style={{ color: "red", fontWeight: "bold", fontSize: "20px" }}>{error}</p>
                      ) : (
                        <Spinner animation="border" />
                      )}
                    </div>
                  )
                )}
              </Col>
            </Row>
          </div>
        </div>

        <footer className='footer-div'>
          <p style={{ color: 'white' }}>&copy; {currentYear} Data Lake Solutions LLC. All rights reserved.</p>
        </footer>
      </div>
    </>
  );
};


export default UsersQuestions;
